import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../lib/api';
import type { ServiceLineDto } from '../lib/types';

export function useServiceLines() {
  return useQuery({
    queryKey: ['service-lines'],
    queryFn: () => apiClient.get<ServiceLineDto[]>('/api/service-lines'),
  });
}
